module.exports = __webpack_public_path__ + "static/img/personal-info.e943da46.png";